export const DISK_TRACK_COUNTS = {
    '4': { 1: 96, 2: 92, 3: 79, 4: 58, 5: 55, 6: 64, 7: 35, 8: 29, 9: 44, 10: 96 },
    '5': { 1: 66, 2: 93, 3: 96, 4: 56, 5: 80, 6: 41, 7: 51, 8: 68, 9: 40, 10: 37 },
    '6': { 1: 36, 2: 46, 3: 34, 4: 16, 5: 38, 6: 45, 7: 10, 8: 31, 9: 30, 10: 31 },
    '7': { 1: 35, 2: 37, 3: 21, 4: 37, 5: 37, 6: 33, 7: 20, 8: 23, 9: 16, 10: 14 },
};

export const CLASS_NUM_MAP = {
    '4 класс': '4',
    '5 класс': '5',
    '6 класс': '6',
    '7 класс': '7',
};

export const GRADE_LABELS = {
    4: '4 класс',
    5: '5 класс',
    6: '6 класс',
    7: '7 класс',
};

export const GRADES = ['4 класс', '5 класс', '6 класс', '7 класс'];

export const gradeToNum = (gradeLabel) => CLASS_NUM_MAP[gradeLabel] || String(gradeLabel);
